import BrandsSection from "../../Components/BrandsSection/BrandsSection";

const Brands = () => {
  return <BrandsSection />;
};
export default Brands;
